import React, { useState, useEffect } from 'react';
import { Col, Card, Row, Button, Modal } from 'react-bootstrap';
import ProgressBar from '../view/ProgressBar';

const ValuationCard = ({ state, prevPage, nextPage }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(state.error);
    const [valuationData, setValuationData] = useState(null);
    const [vehicleDetails, setVehicleDetails] = useState({
        make: '',
        model: '',
        year: ''
    });

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };

    useEffect(() => {
        if (state.valuation) {
            const { tradein, wholesale, private: privateVal, retail } = state.valuation;
            setValuationData({ tradein, wholesale, private: privateVal, retail });

            const vehicleData = state.vehicleData || {};
            const model = vehicleData.model || {};
            const manufacturer = model.manufacturer || {};

            setVehicleDetails({
                make: manufacturer.name || '',
                model: model.name || '',
                year: vehicleData.year || ''
            });
            setLoading(false);
        }
    }, [state]);

    let content;
    const hideDone = state.featureFlags.hideDone;

    if (loading) {
        content = (
            <div className="center-flex">
                <div>Loading vehicle valuation...</div>
            </div>
        );
    } 
    else {
        const defaultValuationTitle = `What's Next?`
        const defaultValuationMessage = `Get real, committed bids from our buyer network by completing an inspection! Our app will take you through a fast inspection process that  will get you the best price for your vehicle. 
        Simply follow the link sent to you via SMS to complete the inspection.`

        const ValuationTitle = state.featureFlags.ValuationTitle;
        const ValuationMessage = state.featureFlags.ValuationMessage;

        const valuationItems = [
            { label: 'Trade-In', value: valuationData.tradein },
            { label: 'Wholesale', value: valuationData.wholesale },
            { label: 'Private', value: valuationData.private },
            { label: 'Retail', value: valuationData.retail }
        ].sort((a, b) => a.value - b.value);

        content = (
            <>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title className="card-title text-center">
                                {vehicleDetails.year} {vehicleDetails.make} {vehicleDetails.model}
                            </Card.Title>
                            <Card.Text>
                                <Row className="text-center mt-3">
                                    {valuationItems.map((item, index) => (
                                        <Col xs={6} md={3} key={index} className="mb-3 mb-md-0">
                                            <div style={{ color: '#6c757d', fontSize: '0.85rem', marginBottom: '4px' }}>
                                                {item.label}
                                            </div>
                                            <div style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                                                {formatCurrency(item.value)}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} className="mt-3">
                    <Card>
                        <Card.Body>
                        <Card.Title className="card-title">
                            {ValuationTitle || defaultValuationTitle}
                        </Card.Title>
                            <Card.Text>
                                <Row>
                                    <Col>
                                    {ValuationMessage || defaultValuationMessage}
                                    </Col>
                                </Row>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </>
        );
    }

    return (
        <>
            <Modal.Header className="mobile-consistent-header">
                <Col className="title-section">
                    <Modal.Title>Vehicle Valuation Summary</Modal.Title>
                </Col>
                <Col className="progress-section">
                    <ProgressBar pageNumber={state.pageNumber} pages={state.pages} featureFlags={state.featureFlags} />
                </Col>
            </Modal.Header>
            <Modal.Body>
                <Row className="mt-4 justify-content-center">
                    {content}
                </Row>

                <Row className='row-buttons'>
                    <Col className='row-button-left'>
                        <Button
                            type="button"
                            variant='outline-dark'
                            onClick={prevPage}
                        >
                            Go Back
                        </Button>
                    </Col>
                    {!loading && !hideDone && (
                        <Col className='row-button-right'>
                            <Button
                                variant="outline-dark"
                                onClick={nextPage}
                                disabled={!!error}
                            >
                                Next
                            </Button>
                        </Col>
                    )}
                </Row>
            </Modal.Body>
        </>
    );
};

export default ValuationCard;